jQuery(function ($) {

    // Field name must match CF7::HIDDEN_FIELD in src/CF7.php.
    $(document).on('wpcf7mailsent', function (event) {
        var url = $(event.target).find('input[name="_cf7_redirect_url"]').val();

        if (url) {
            window.location.href = url;
        }
    });

});
